import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';

@Component({
  selector: 'app-form-field-link',
  templateUrl: './link-form-field.component.html',
  styleUrls: ['link-form-field.component.scss'],
  standalone: false,
})
export class LinkFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  matcher = new MyErrorStateMatcher();

  hrefData: string;

  rowData: any;

  ngOnDestroy() {}

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    return this.getValidatorConfig(v).condition(formControl);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  ngOnInit(): void {
    if (this.fieldConfig.externalLink) {
      const externalLinkJs = this.fieldConfig.externalLink;
      const data = this.rowData;
      this.hrefData = eval(externalLinkJs);
    } else {
      this.hrefData = this.data;
    }
  }

  public copyOne() {
    const el: any = document.createElement('textarea');
    el.value = this.data;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }
}
